import Menu from 'components/menu/menu';

export default Menu;
